<footer class="footer">
  <p>&copy; 2026 HouseDeal. All rights reserved.</p>
</footer>
